<h4>{{episode.title}}</h4>
<p>{{episode.description}}</p>
<p>Season {{episode.season}} - Episode {{episode.episode_number}}</p>
<p *ngIf="episode.downloadLink !== null">Episode key: {{episode.downloadLink}}</p>
<label for="{{episode.id}}-upload">Upload Audio</label>
<input type="file" id="{{episode.id}}-upload" (change)="onFileChange($event.target.files)">

